import React from 'react';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
  options: { label: string; value: string; disabled?: boolean }[];
}

export function Select({
  label,
  value,
  onChange,
  options,
  error,
  disabled = false,
  hint,
  style,
  ...props
}: SelectProps) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontFamily: 'var(--font-body)', width: '100%', ...style }}>
      {label && (
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-secondary)', fontWeight: 'var(--fw-medium)' }}>
          {label}
        </span>
      )}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          background: 'var(--bg-inset)',
          color: 'var(--text-primary)',
          border: `1px solid ${error ? 'var(--danger)' : 'var(--border-default)'}`,
          borderRadius: 'var(--radius-md)',
          padding: '9px 12px',
          fontSize: 'var(--text-sm)',
          fontFamily: 'var(--font-body)',
          outline: 'none',
          opacity: disabled ? 0.5 : 1,
          boxSizing: 'border-box',
          width: '100%',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onFocus={(e) => {
          e.target.style.boxShadow = 'var(--focus-ring)';
          e.target.style.borderColor = 'var(--accent)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = error ? 'var(--danger)' : 'var(--border-default)';
        }}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} disabled={opt.disabled} style={{ background: 'var(--navy-850)', color: 'var(--text-primary)' }}>
            {opt.label}
          </option>
        ))}
      </select>
      {hint && !error && (
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>{hint}</span>
      )}
      {error && <span style={{ fontSize: 'var(--text-xs)', color: 'var(--danger)' }}>{error}</span>}
    </label>
  );
}
